// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { ResultsBaseService } from './results-base.service';
import {
  HeartstylesQuadrants,
  IndicatorScoreModel,
  QuadrantModel,
  QuestionCategories,
  SurveyResultModel,
  SurveyResultsModel,
} from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class ResultsMockService extends ResultsBaseService {
  constructor() {
    super();
  }

  loadSurveyResults(identifier: string): void {
    const results = {
      self: {
        fear: {
          heading: 'Fear',
          subHeading: 'Self Protecting',
          index: 4,
          quadrant: HeartstylesQuadrants.fear,
          score: 15,
          indicators: [
            {
              categoryName: 'Approval Seeking',
              categoryType: QuestionCategories.approvalSeeking,
              index: 1,
              quadrant: HeartstylesQuadrants.fear,
              score: 14,
            } as IndicatorScoreModel,
            {
              categoryName: 'Easily Offended',
              categoryType: QuestionCategories.easilyOffended,
              index: 2,
              quadrant: HeartstylesQuadrants.fear,
              score: 24,
            } as IndicatorScoreModel,
            {
              categoryName: 'Dependent',
              categoryType: QuestionCategories.dependent,
              index: 3,
              quadrant: HeartstylesQuadrants.fear,
              score: 34,
            } as IndicatorScoreModel,
            {
              categoryName: 'Avoiding',
              categoryType: QuestionCategories.avoiding,
              index: 4,
              quadrant: HeartstylesQuadrants.fear,
              score: 44,
            } as IndicatorScoreModel,
          ] as IndicatorScoreModel[],
        } as QuadrantModel,
        humility: {
          heading: 'Humility',
          subHeading: 'Personal Growth',
          index: 1,
          quadrant: HeartstylesQuadrants.humility,
          score: 90,
          indicators: [
            {
              categoryName: 'Authentic',
              categoryType: QuestionCategories.authentic,
              index: 1,
              quadrant: HeartstylesQuadrants.humility,
              score: 90,
            } as IndicatorScoreModel,
            {
              categoryName: 'Transforming',
              categoryType: QuestionCategories.transforming,
              index: 2,
              quadrant: HeartstylesQuadrants.humility,
              score: 70,
            } as IndicatorScoreModel,
            {
              categoryName: 'Reliable',
              categoryType: QuestionCategories.reliable,
              index: 3,
              quadrant: HeartstylesQuadrants.humility,
              score: 50,
            } as IndicatorScoreModel,
            {
              categoryName: 'Achieving',
              categoryType: QuestionCategories.achieving,
              index: 4,
              quadrant: HeartstylesQuadrants.humility,
              score: 30,
            } as IndicatorScoreModel,
          ] as IndicatorScoreModel[],
        } as QuadrantModel,
        love: {
          heading: 'Love',
          subHeading: 'Growing Others',
          index: 2,
          quadrant: HeartstylesQuadrants.love,
          score: 65,
          indicators: [
            {
              categoryName: 'Relating',
              categoryType: QuestionCategories.relating,
              index: 1,
              quadrant: HeartstylesQuadrants.love,
              score: 80,
            } as IndicatorScoreModel,
            {
              categoryName: 'Encouraging',
              categoryType: QuestionCategories.encouraging,
              index: 2,
              quadrant: HeartstylesQuadrants.love,
              score: 70,
            } as IndicatorScoreModel,
            {
              categoryName: 'Developing',
              categoryType: QuestionCategories.developing,
              index: 3,
              quadrant: HeartstylesQuadrants.love,
              score: 60,
            } as IndicatorScoreModel,
            {
              categoryName: 'Compassionate',
              categoryType: QuestionCategories.compassionate,
              index: 4,
              quadrant: HeartstylesQuadrants.love,
              score: 50,
            } as IndicatorScoreModel,
          ] as IndicatorScoreModel[],
        } as QuadrantModel,
        pride: {
          heading: 'Pride',
          subHeading: 'Self Promiting',
          index: 1,
          quadrant: HeartstylesQuadrants.pride,
          score: 25,
          indicators: [
            {
              categoryName: 'Sarcastic',
              categoryType: QuestionCategories.sarcastic,
              index: 1,
              quadrant: HeartstylesQuadrants.pride,
              score: 25,
            } as IndicatorScoreModel,
            {
              categoryName: 'Competitive',
              categoryType: QuestionCategories.competitive,
              index: 2,
              quadrant: HeartstylesQuadrants.pride,
              score: 45,
            } as IndicatorScoreModel,
            {
              categoryName: 'Controlling',
              categoryType: QuestionCategories.controlling,
              index: 3,
              quadrant: HeartstylesQuadrants.pride,
              score: 65,
            } as IndicatorScoreModel,
            {
              categoryName: 'Striging',
              categoryType: QuestionCategories.striving,
              index: 4,
              quadrant: HeartstylesQuadrants.pride,
              score: 85,
            } as IndicatorScoreModel,
          ] as IndicatorScoreModel[],
        } as QuadrantModel,
      } as SurveyResultModel,
      benchmark: {} as SurveyResultModel,
    } as SurveyResultsModel;

    this._surveyResults$.next(results);
  }
}
